import { render, staticRenderFns } from "./SiteRecord.vue?vue&type=template&id=78c1722b"
import script from "./SiteRecord.vue?vue&type=script&lang=js"
export * from "./SiteRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports